import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

const AccordionHead = ({ handleClick, title, isExpanded, dataTestId }) => {
  return (
    <Box
      borderTop="1px solid"
      color="borders.primary"
      pt={1}
      pb={1.25}
      position="relative"
    >
      <Grid
        container
        component={Button}
        onClick={handleClick}
        fullWidth
        justify="space-between"
        data-testid={dataTestId}
      >
        <Typography variant="h2">{title}</Typography>
        {isExpanded ? <ExpandLess /> : <ExpandMore />}
      </Grid>
    </Box>
  );
};

AccordionHead.propTypes = {
  title: PropTypes.string,
  isExpanded: PropTypes.bool,
  handleClick: PropTypes.func,
  dataTestId: PropTypes.string
};

export default AccordionHead;
